module.exports = __webpack_public_path__ + "img/db_helvethaicaais_x_bd_v3.2-webfont.f1265eae.svg";